export default __webpack_public_path__ + "static/media/oak.145eb625.png";